'use client';

import { useState } from 'react';

import { FaCreditCard, FaBookOpen } from 'react-icons/fa';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card } from '@/types/Card';

import CategoryCardsLayout from '../layout/CategoryCardsLayout';

interface CategoryTabsProps {
  category: {
    id: string;
    name: string;
    description: string;
    cards: Card[];
  };
}

export function CategoryTabs({ category }: CategoryTabsProps) {
  const [activeTab, setActiveTab] = useState('cards');

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="relative w-full max-w-md mb-6 p-1 bg-gray-100 dark:bg-gray-800 rounded-xl mx-auto">
        <div className="absolute inset-0 flex">
          <div
            className="h-10 bg-white dark:bg-gray-700 rounded-lg shadow-sm transition-all duration-300 ease-in-out"
            style={{
              width: 'calc(50% - 0.5rem)',
              transform: `translateX(${activeTab === 'cards' ? '0' : 'calc(100% + 1rem)'})`,
            }}
          />
        </div>
        <TabsTrigger
          value="cards"
          className="relative z-10 flex-1 h-12 px-4 font-medium text-sm transition-colors duration-300"
        >
          <FaCreditCard className="mr-2 h-4 w-4 mt-1" />
          推薦卡片
        </TabsTrigger>
        <TabsTrigger
          value="guide"
          className="relative z-10 flex-1 h-12 px-4 font-medium text-sm transition-colors duration-300"
        >
          <FaBookOpen className="mr-2 h-4 w-4 mt-1" />
          用卡攻略
        </TabsTrigger>
      </TabsList>

      <TabsContent value="cards" className="mt-0" id="cards-section">
        <CategoryCardsLayout category={category} />
      </TabsContent>

      <TabsContent value="guide" id="guide-section">
        <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow">
          <h2 className="text-2xl font-bold mb-4">{category.name}信用卡使用攻略</h2>
          <div className="prose dark:prose-invert max-w-none">
            <p className="text-lg mb-4">
              掌握{category.name}消費的秘訣，讓您每一筆消費都更划算！以下是精選的{category.name}
              信用卡使用技巧：
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
              <li>比較不同卡片的回饋率，選擇最適合您消費習慣的卡片</li>
              <li>注意優惠期間和回饋上限，避免錯過最佳回饋時機</li>
              <li>結合行動支付或特定通路優惠，可獲得更高回饋</li>
              <li>定期檢視您的消費明細，確保回饋正確入帳</li>
            </ul>
          </div>
        </div>
      </TabsContent>
    </Tabs>
  );
}
